import React from 'react'
import { ReportRouteImport } from './Imports'
const {
    RoutesMap, DowntimeAnalysis, FilterAssetData, AuditList, AuditDetails,
    AssetDepreciationReport, AssetAgeReport, AssetMovementReport, AssetsDueDisposalReport,
    WorkOrderSummaryReport, MaintenanceHistoryAssetReport, PlannedVsActualReport, OverdueMaintenanceReport,
    AmcReport,
} = ReportRouteImport

const ReportRoute = () => {
    return [
        {
            path: RoutesMap.REPORT.path,
            element: <DowntimeAnalysis />
        },
        {
            path: RoutesMap.FILTER.path,
            element: <FilterAssetData />
        },
        {
            path: RoutesMap.AUDIT_REPORT.path,
            element: <AuditList />
        },
        {
            path: RoutesMap.AUDIT_REPORT_DETAILS.path,
            element: <AuditDetails />
        },
        {
            path: RoutesMap.ASSET_DEPRECIATION_REPORT.path,
            element: <AssetDepreciationReport />
        },
        {
            path: RoutesMap.ASSET_AGE_REPORT.path,
            element: <AssetAgeReport />
        },
        {
            path: RoutesMap.ASSET_MOVEMENT_REPORT.path,
            element: <AssetMovementReport />
        },
        {
            path: RoutesMap.ASSETS_DUE_DISPOSAL_REPORT.path,
            element: <AssetsDueDisposalReport />
        },
        {
            path: RoutesMap.WORK_ORDER_SUMMARY_REPORT.path,
            element: <WorkOrderSummaryReport />
        },
        {
            path: RoutesMap.MAINTENANCE_HISTORY_ASSET_REPORT.path,
            element: <MaintenanceHistoryAssetReport />
        },
        {
            path: RoutesMap.PLANNED_VS_ACTUAL_REPORT.path,
            element: <PlannedVsActualReport />
        },
        {
            path: RoutesMap.OVERDUE_MAINTENANCE_REPORT.path,
            element: <OverdueMaintenanceReport />
        },
        {
            path: RoutesMap.AMC_REPORT.path,
            element: <AmcReport />
        },

    ]
}

export default ReportRoute;
